<template>
  <div class="p-home_banner m-is-transparent">
    <kf-video
      class="__video"
      :src="contentInfo.video"
      :poster="dataInfo.cover"
      :autoplay="true"
      :muted="true"
      :controls="false"
      :preload="true"
      :fluid="true"
      :loop="true"
      v-if="contentInfo.video"
    />
    <!-- <div
      v-if="contentInfo.image"
      :style="{
        backgroundImage: 'url(' + contentInfo.image + ')'
      }"
      class="__make"
    ></div> -->
    <img
      v-if="contentInfo.image"
      :src="contentInfo.image"
      width="100%"
      @click="toDetail"
      class="ban-img"
      alt=""
    />
    <div class="inner-con" v-if="contentInfo.image">
      <div class="content">
        <!-- <img :src="contentInfo.image" alt="" class="img" /> -->
      </div>
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../../mixins/pageMain_mx";
import kfVideo from "../../../components/kf-video.vue";

export default {
  mixins: [pageMain_mx],
  data() {
    return {
      dataInfo: {},
      contentInfo: {},
      banner: {}
    };
  },
  props: {
    menuId: {
      type: String,
      default: ""
    },
    pageType: {
      type: String,
      default: ""
    }
  },
  components: { kfVideo },
  async mounted() {
    const dataInfo = await this.getMenuInfo(this.menuId);
    const data = await this.getMenuList({
      pageNum: 1,
      pageSize: 1,
      menuId: this.menuId
    });
    this.contentInfo = data[0];
    this.dataInfo = dataInfo;
  },
  methods: {
    toDetail() {
      this.toUrl(this.contentInfo.url);
    }
  }
};
</script>
<style lang="less">
.p-home_banner {
  // height: calc(100vh + 88px);

  overflow: hidden;
  position: relative;
  min-height: 675px;
  z-index: 1;
  box-sizing: border-box;
  .__video {
    position: absolute;
    left: 0;
    top: 0;
    // margin-left: -50%;
    // margin-top: -540px;
    width: 100%;
    height: 100%;
    // width: 100vw;
    // min-width: 1920px;
    // height: 1080px;
    z-index: -2;
  }
  .video-js {
    width: 100%;
    height: 100%;
  }
  .__make {
    // position: absolute;
    // left: 0;
    // top: 0;
    // width: 100%;
    // height: 100%;
    // background-color: rgba(0, 14, 49, 0.4);
    // z-index: -1;
    position: absolute;
    // left: 50%;
    // top: 50%;
    // margin-left: -50%;
    // margin-top: -540px;
    // width: 100vw;
    // min-width: 1920px;
    // height: 1080px;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 2;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  .inner-con {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    .content {
      width: 100%;
      height: auto;
      .img {
        width: 100%;
        height: auto;
      }
    }
  }
  .ban-img {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
